import React, {
  FC,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import "./DateRangePicker.scss";
import { dateRange, lang } from "./../../models/index";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
import { enUS, arSA } from "date-fns/locale";
import {
  DateRangePicker,
  defaultStaticRanges,
  defaultInputRanges,
} from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css";
//import { defaultStaticRanges,  defaultInputRanges } from "react-date-range/dist/defaultRanges";

import { useTranslation } from "react-i18next";
import { CalendarIcon } from "../../components/Icons/CheckOutLogo";
import ThemeContext from "../../ThemeContext";
import { handleLangugeDirection } from "../../components/commonFunctions";

interface staticRanges {
  Today: string;
  Yesterday: string;
  ThisWeek: string;
  LastWeek: string;
  ThisMonth: string;
  LastMonth: string;
  ThisYear: string;
  LastYear: string;
}

interface Dateinfo {
  startDate: Date;
  endDate: Date;
  key?: string;
  color?: string;
  autoFocus?: boolean;
}

interface DateRangeProps {
  getDateRange: (item: dateRange) => void;
  showDates?: boolean;
  title?: string;
  customButton?: () => JSX.Element;
}

export function translateRange(dictionary: any) {
  return (item: any) =>
    dictionary[item.label]
      ? { ...item, label: dictionary[item.label] }
      : item;
}



const DateRangePickerComponent: FC<DateRangeProps> = ({
  getDateRange,
  showDates = true,
  title = "",
  customButton,
}) => {
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  const themes = useContext(ThemeContext);
  const [state, setState]: any = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
      color: themes.MainGreenColorHexa,
      autoFocus: true,
    },
  ]);
  const [toggledatepicker, setToggledatepicker] = useState(false);
  const { t } = useTranslation("translation", { keyPrefix: "dynamicTab" });
  const staticRangesLabels: staticRanges = t("staticRange", {returnObjects: true,});

  const inputRangesLabels = t("inputRange", { returnObjects: true });

  /* function translateRange(dictionary: any) {
    return (item: any) =>
      dictionary[item.label]
        ? { ...item, label: dictionary[item.label] }
        : item;
  }
 */
  const ruStaticRanges = defaultStaticRanges.map(
    translateRange(staticRangesLabels)
  );

  const ruInputRanges = defaultInputRanges.map(
    translateRange(inputRangesLabels)
  );

  const toggleDatePicker = () => {
    setToggledatepicker(!toggledatepicker);
  };

  const handleFormateDate = (date: Date) => {
    /* console.log(date); */
    var year = date.getFullYear();
    var month: any = date.getMonth() + 1;
    var day: any = date.getDate();
    if (day < 10) {
      day = `0${day}`;
    }
    if (month < 10) {
      month = `0${month}`;
    }

    var formatedDate = `${year}-${month}-${day}`;

    return formatedDate;
  };

  useLayoutEffect(() => {
    if (toggledatepicker) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [toggledatepicker]);

  const handleGetDateRange = () => {
    getDateRange({
      startDate: handleFormateDate(state[0].startDate),
      endDate: handleFormateDate(state[0].endDate),
    });
    toggleDatePicker();
  };

 /*  useEffect(() => {

    getDateRange({
      startDate: handleFormateDate(state[0].startDate),
      endDate: handleFormateDate(state[0].endDate),
    });
  }, []);
 */



  return (

    <div className="calender">
      <div className="date-filter">
        {!customButton ? (
          <button
            className="button-secondary-light"
            onClick={toggleDatePicker}
          >
            {/* {showDates && (
                                <span>
                                    {`${state[0].startDate.toDateString()} - ${state[0].endDate.toDateString()}`}
                                </span>
                            )} */}
            <CalendarIcon />
          </button>
        ) : (
          <div onClick={toggleDatePicker}>{customButton()}</div>
        )}
        {toggledatepicker && (
          <div className="hover-back" onClick={toggleDatePicker}>
            <div
              className="date-filter-container"
              onClick={(event: any) => {
                event.stopPropagation();
              }}
            >
              <div className="font-h3">{title}</div>
              <DateRangePicker
                locale={handleLangugeDirection(lang ,"locale" , {} , {arSA , enUS} )/* lang === "en" ||lang === "fr"? enUS : arSA */}
                onChange={(item: any) => setState([item.selection])}
                moveRangeOnFirstSelection={false}
                maxDate={new Date()}
                weekStartsOn={6}
                months={1}
                ranges={state}
                direction="horizontal"
                staticRanges={[
                  ...ruStaticRanges,
                  {
                    label: staticRangesLabels.LastYear,
                    range: () => ({
                      startDate: startOfYear(addYears(new Date(), -1)),
                      endDate: endOfYear(addYears(new Date(), -1)),
                    }),
                    isSelected(range: any) {
                      const definedRange: any = this.range();
                      return (
                        isSameDay(range.startDate, definedRange.startDate) &&
                        isSameDay(range.endDate, definedRange.endDate)
                      );
                    },
                  },
                  {
                    label: staticRangesLabels.ThisYear,
                    range: () => ({
                      startDate: startOfYear(new Date()),
                      endDate: endOfDay(new Date()),
                    }),
                    isSelected(range: any) {
                      const definedRange: any = this.range();
                      return (
                        isSameDay(range.startDate, definedRange.startDate) &&
                        isSameDay(range.endDate, definedRange.endDate)
                      );
                    },
                  },
                ]}
                inputRanges={ruInputRanges}
              />
              <div className="date-filter-buttons">
                <button
                  className="button-primary-light"
                  onClick={handleGetDateRange}
                >
                  {t("apply")}{" "}
                </button>
                {/* <button className='cancel' onClick={toggleDatePicker}>   { t("cancel")}</button> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>

  );
};

export default DateRangePickerComponent;
